import React from 'react';
import { BuyButton } from '@annunciate/ui/dist/components/buttons/BuyButton';
import { ContentButtons } from '@annunciate/ui/dist/components/content/ContentButtons';
import { useIsEntitledQuery } from '@annunciate/query';
export const ContentButtonBar = ({ item, isLoading = false, }) => {
    const isEntitled = useIsEntitledQuery(item);
    const isDownload = !!item?.isDownload;
    if (isLoading || !item) {
        return null;
    }
    else if (isEntitled || isDownload) {
        return (React.createElement(ContentButtons, { item: item }));
    }
    else {
        return (React.createElement(BuyButton, { item: item }));
    }
};
//# sourceMappingURL=ContentButtonBar.js.map